import React, { useState, useEffect } from 'react'
import { Box, Heading, Button, Loading, Input, Text, Checkbox } from '@/components/lib'
import { useParams, Link } from 'react-router'
import api from '../../api'
import utils from '../../utils/utils'
import useStore from '../../store'

const FEATURES = [
  { key: 'basicDataTypes', name: 'Basic data types' },
  { key: 'cognitionDataTypes', name: 'Cognitive data types' },
  { key: 'foodDataType', name: 'Nutrition data type' },
  { key: 'foodDiaries', name: 'Food diaries' },
  { key: 'fileDataType', name: 'File data type' },
  { key: 'imageDataType', name: 'Image data type' },
  { key: 'videoDataType', name: 'Video data type' },
  { key: 'mobileApp', name: 'Mobile app' },
  { key: 'integrations', name: 'Integrations' },
  { key: 'advancedExport', name: 'SPSS and Graphpad export' },
  { key: 'eConsent', name: 'eConsent' },
  { key: 'sms', name: 'SMS' },
  { key: 'whatsapp', name: 'WhatsApp' },
  { key: 'eTmf', name: 'eTMF' },
  { key: 'pollMode', name: 'Poll mode' },
  { key: 'fitbit', name: 'Fitbit wearables' },
  { key: 'garmin', name: 'Garmin wearables' },
  { key: 'dexcom', name: 'Dexcom integration' },
  { key: 'simplyBookEmbed', name: 'SimplyBook embed' },
  { key: 'siteMonitoring', name: 'Site monitoring' },
  { key: 'packs', name: 'Packs' },
  { key: 'queries', name: 'Queries' },
  { key: 'smartAutomaticQueries', name: 'Smart automatic queries' },
  { key: 'tasks', name: 'Tasks' },
  { key: 'sdv', name: 'SDV' },
  { key: 'redcapImport', name: 'REDCap import' },
  { key: 'generateStagesAI', name: 'Generate stages (AI)' },
  { key: 'calculationDataType', name: 'Calculation data type' },
  { key: 'videoCalls', name: 'Video calls' },
  { key: 'econsentKyc', name: 'eConsent KYC' },
  { key: 'promis', name: 'PROMIS questionnaires' },
  { key: 'participantIncentives', name: 'Participant incentives' },
  { key: 'questionnaireLibrary', name: 'Questionnaire library' },
  { key: 'aiAssistant', name: 'Trial AI assistant' },
  { key: 'mcpAccess', name: 'External AI connectors (MCP)' },
  { key: 'mcpWrite', name: 'External AI connectors — allow writes' },
  { key: 'participantInsights', name: 'Participant AI insights' },
  { key: 'trialInsights', name: 'Trial AI insights' },
  { key: 'participantResources', name: 'Participant resources' },
  { key: 'teethChart', name: 'Teeth chart' },
  { key: 'participantLoginLinks', name: 'Participant login links' }
]

function RootEditTeam () {
  const [loading, setLoading] = useState(false)
  const [team, setTeam] = useState()
  const { teamId } = useParams()
  const { user } = useStore()

  useEffect(() => {
    if (!user) return
    setLoading(true)
    if (!teamId) return
    api.root.getTeam(teamId, team => {
      setLoading(false)
      setTeam(team)
    })
  }, [teamId, user])

  const update = (key, value) => {
    const newTeam = Object.assign({}, team)
    newTeam[key] = value
    setTeam(newTeam)
  }
  const toggleFeature = (feature) => {
    const features = Object.assign([], team.enabledFeatures || [])
    const index = features.indexOf(feature.key)
    if (index === -1) features.push(feature.key)
    else features.splice(index, 1)
    update('enabledFeatures', features)
  }

  const save = () => {
    api.root.updateTeam(teamId, {
      maxUsers: team.maxUsers,
      maxTrials: team.maxTrials,
      maxParticipants: team.maxParticipants,
      maxParticipantsPerTrial: team.maxParticipantsPerTrial,
      enabledFeatures: team.enabledFeatures
    }, newTeam => {
      setTeam(newTeam)
      utils.toast('success', 'Team updated')
    }, err => {
      utils.toast('error', err.message)
    })
  }

  if (loading) return <Loading />
  if (!team) return null
  return (
    <Box>
      <Button size='sm' as={Link} to='/root'>Back to root</Button>
      <Heading size='md' mt={10} mb={3}>Edit team {team.name}</Heading>

      <Box p={3} rounded='md' bg='bg.surface'>
        <Heading size='sm'>Team Limits</Heading>

        <Text mt={3}>Max users (team seats)</Text>
        <Input placeholder='5' value={team.maxUsers} onChange={e => update('maxUsers', parseInt(e.target.value))} />

        <Text mt={3}>Max trials</Text>
        <Input placeholder='5' value={team.maxTrials} onChange={e => update('maxTrials', parseInt(e.target.value))} />

        <Text mt={3}>Max participants (across all trials)</Text>
        <Input placeholder='5' value={team.maxParticipants} onChange={e => update('maxParticipants', parseInt(e.target.value))} />

        <Text mt={3}>Max participants per trial</Text>
        <Input placeholder='5' value={team.maxParticipantsPerTrial} onChange={e => update('maxParticipantsPerTrial', parseInt(e.target.value))} />
      </Box>

      <Box p={3} rounded='md' bg='bg.surface' mt={5}>
        <Heading size='sm'>Enabled Features</Heading>

        {FEATURES.map(feature =>
          <Checkbox
            key={feature.key} m={3}
            isChecked={team.enabledFeatures?.indexOf(feature.key) > -1}
            onChange={e => toggleFeature(feature)}
          >
            {feature.name}
          </Checkbox>
        )}

      </Box>

      <Button mt={5} onClick={save} colorPalette='primary'>Save changes</Button>
    </Box>
  )
}

export default RootEditTeam
